import { render, staticRenderFns } from "./FollowUpItem.vue?vue&type=template&id=2e0270bc&scoped=true&"
import script from "./FollowUpItem.vue?vue&type=script&lang=js&"
export * from "./FollowUpItem.vue?vue&type=script&lang=js&"
import style0 from "./FollowUpItem.vue?vue&type=style&index=0&id=2e0270bc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e0270bc",
  null
  
)

export default component.exports